import { render, staticRenderFns } from "./Distributors.html?vue&type=template&id=02280296&external"
import script from "./Distributors.js?vue&type=script&lang=js&external"
export * from "./Distributors.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports